<template lang="pug">
  div
    ValidationProvider(
      v-if="canDelete"
      :rules="rules"
      v-slot="{ errors }"
      :name="wrapQuotesProviderName(name)"
      ref="validation"
    )
      div(
        class="uploader"
        :class="{ errored: errors.length, 'drag-n-drop': dragover }"
        @drop.prevent="onDrop($event)"
        @dragover.prevent="dragover = true"
        @dragenter.prevent="dragover = true"
        @dragleave.prevent="dragover = false"
      )
        img(
          v-if="uploaderBackgroundImage"
          :src="uploaderBackgroundImage"
          :style="uploaderBackgroundImageStyles"
        )
        div(class="uploader__content")
          div(class="text-14px medium dark mb-1") {{ $t('Drag files here') }}
          slot(name="description")
          v-btn(
            class="secondary-button sm"
            data-test="uploader-choose-file-btn"
            @click="openFileMenu"
          ) {{ $t('Choose file') }}
          v-file-input(
            v-show="false"
            ref="fileInput"
            type="file"
            :accept="accept"
            :value="value"
            :multiple="multiple"
            @change="selectFiles($event)"
          )
      div(
        v-if="errors.length"
        class="text-12px errored pt-2 pl-3"
      ) {{ errors[0] }}
    template(v-if="showLoadedFiles")
      template(v-if="multiple")
        e-file-uploaded(
          v-for="(file, idx) in value"
          :key="idx"
          :file-name="file.name"
          :file-size="file.size"
          :can-delete="canDelete"
          @remove="removeFileByIdx(idx)"
        )
      template(v-else)
        e-file-uploaded(
          :file-name="value.name"
          :file-size="value.size"
          :can-delete="canDelete"
          @remove="$emit('input', null)"
        )
</template>

<script>
import validate from '~/mixins/validation/validate'
import EFileUploaded from '~/components/elements/e-file-uploaded'

export default {
  name: 'EInputFileUpload',
  components: { EFileUploaded },
  mixins: [validate],
  props: {
    value: {
      type: [Array, Object, File, FileList],
      default: null
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    rules: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: null
    },
    allowedExtensions: {
      type: Object,
      default: () => ({})
    },
    accept: {
      type: String,
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    uploaderBackgroundImage: {
      type: String,
      default: null
    },
    uploaderBackgroundImageStyles: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    dragover: false
  }),
  computed: {
    showLoadedFiles() {
      return this.multiple ? this.value?.length : this.value
    }
  },
  methods: {
    validate() {
      return this.$refs.validation.validate()
    },
    openFileMenu() {
      this.$refs.fileInput.$refs.input.click()
    },
    selectFiles(files) {
      const fileListArray = Array.from(files || [])
      this.$emit('input', fileListArray.length ? fileListArray : files)
    },
    removeFileByIdx(index) {
      const copyFiles = this._.cloneDeep(this.value)
      const filteredFiles = this._.filter(copyFiles, (file, idx) => idx !== index)
      this.$emit('input', filteredFiles)
    },
    onDrop(e) {
      this.dragover = false
      const fileList = Array.from(e.dataTransfer.files)
      const validFiles = []
      fileList.map(file => {
        const isAllowedExtension = Object.values(this.allowedExtensions).includes(file.type)

        if (!isAllowedExtension) {
          this.$handlers.error('File format is not allowed to download', this)
        } else {
          validFiles.push(file)
        }
      })
      if (validFiles.length === fileList?.length) {
        const fileArray = Array.from(e.dataTransfer.files)
        this.$emit('input', fileArray)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.uploader {
  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  height: 200px;

  cursor: pointer;
  border-radius: 12px;
  border: 2px dashed $border-terteriary;
  background: $background-gray;

  padding: 40px 56px;

  &.errored {
    border-color: $danger;
  }

  &.drag-n-drop {
    border-color: $primary;
  }

  &__content {
    text-align: center;
  }
}
</style>
